import { render, staticRenderFns } from "./FormIncidentGeneralDetail.vue?vue&type=template&id=55c3f253&scoped=true&"
import script from "./FormIncidentGeneralDetail.vue?vue&type=script&lang=js&"
export * from "./FormIncidentGeneralDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormIncidentGeneralDetail.vue?vue&type=style&index=0&id=55c3f253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c3f253",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c3f253')) {
      api.createRecord('55c3f253', component.options)
    } else {
      api.reload('55c3f253', component.options)
    }
    module.hot.accept("./FormIncidentGeneralDetail.vue?vue&type=template&id=55c3f253&scoped=true&", function () {
      api.rerender('55c3f253', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/handling/FormIncidentGeneralDetail.vue"
export default component.exports